import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './se-utility-nav.css.lit';
import '../se-container/se-container';

/**
 * The SeUtilityNav component
 * @element se-utility-nav
 * @slot utility - utility nav markup
 * @slot translate - gTranslate markup/module
 */
@customElement('se-utility-nav')
export class SeUtilityNav extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <section class="utility-nav--wrapper">
        <se-container>
          <div class="utility-nav">
            <slot name="utility"></slot>
            <slot name="translate"></slot>
          </div>
        </se-container>
      </section>
    `;
  }
}
